module.exports = __webpack_public_path__ + "img/icon-success-ani.316ddecb.svg";